import { SexFlug } from "../../../assets/data/Constants";
import { StaffList } from "../../../type/apiType/IAPI_CON003";
import { TypeTableBody } from "../../../type/componentsType/TkTable";
import { TkGetCode } from "../../../utils/TkGetCode";

function funBodyList(staffList: StaffList[]) {
  const bodyList: TypeTableBody[][] = staffList?.map((item) => [
    {
      children: (item.staffNo ?? "") + ":" + (item.staffNameKanji ?? ""),
      forSort: item.staffNo,
    },
    {
      children: TkGetCode(SexFlug, item.sex),
      forSort: item.sex,
      align: "center",
    },
    {
      children: item.birthday,
      forSort: item.birthday,
      align: "center",
    },
    {
      children: item.joinDate,
      forSort: item.joinDate,
      align: "center",
    },
  ]);

  return bodyList;
}

export { funBodyList };
